/**
 * Returns the base path for assets depending on Vite's configured BASE_URL.
 */
export function getBasePath(): string {
  try {
    if (typeof import.meta !== 'undefined' && import.meta.env?.BASE_URL) {
      const base = import.meta.env.BASE_URL;
      return base === './' || base === '/' ? '' : base.replace(/\/$/, '');
    }
  } catch {
    // Ignore in non-Vite/test environments
  }
  return '';
}

export default getBasePath;
